import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'panel'];

  select(event) {
    const selectedName = event.currentTarget.dataset.tabsName;

    this.tabTargets.forEach((tab) => {
      const isSelected = tab.dataset.tabsName === selectedName;
      tab.classList.toggle('active', isSelected);
      tab.setAttribute('aria-selected', isSelected);
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    this.panelTargets.forEach((panel) => {
      const isSelected = panel.dataset.tabsName === selectedName;
      panel.classList.toggle('show', isSelected);
      panel.classList.toggle('active', isSelected);
      panel.hidden = !isSelected;
    });
  }
}
